<template>
  <div class="p-login">
    <h2 class="brand-text">
      <v-img :src="logo" max-height="150" max-width="250"></v-img>
      <!-- Inf<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 24 24"><path d="M18.572 6c-6.018 0-8.414 10-13.143 10-2.114 0-3.479-1.578-3.479-4s1.366-4 3.479-4c1.666 0 2.862 1.069 4.017 2.395l1.244-1.561c-1.499-1.533-3.05-2.834-5.261-2.834-3.197 0-5.429 2.455-5.429 6s2.232 6 5.429 6c6.003 0 8.407-10 13.143-10 2.113 0 3.479 1.578 3.479 4s-1.365 4-3.479 4c-1.664 0-2.86-1.068-4.015-2.392l-1.244 1.561c1.499 1.531 3.05 2.831 5.259 2.831 3.197 0 5.428-2.455 5.428-6s-2.231-6-5.428-6z"/></svg>rder -->
      <h1 class="admin-title-style mt-8">ADMIN</h1>
    </h2>
    <div class="login-block">
      <v-form @submit.prevent="login()">
        <v-text-field
          v-model="username"
          class="i-v-input"
          prepend-inner-icon="person"
          label="Username"
          single-line
          solo
        ></v-text-field>
        <v-text-field
          v-model="password"
          class="i-v-input"
          prepend-inner-icon="lock"
          type="password"
          label="Password"
          single-line
          solo
        ></v-text-field>
        <span
          class="error-display"
          :hidden="!invalid"
        >
          Invalid username or password
        </span>
        <v-btn
          type="submit"
          text
          :ripple="false"
          class="ma-0 ex-btn ex-primary-btn w-100"
        >
          Sign in
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/img/LogoInforderAdmin.png'

export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: '',
    invalid: false,
    loginRequestPending: false
  }),
  methods: {
    login () {
      if (this.username !== '' && this.password !== '') {
        this.loginRequestPending = true
        this.$store.dispatch('authModule/getUser', {
          username: this.username,
          password: this.password
        }).then((res) => {
          console.log('login', res)
          if (res === 1) {
            this.$router.replace('/production')
            // Get Color
            // this.$store.dispatch('auth/getThemeColor')
            // Get Params
            // this.$store.dispatch('auth/getAccountParams').then(() => {
            //   this.loginRequestPending = false
            //   this.$router.replace('/dashboard')
            // })
          } else {
            this.loginRequestPending = false
            this.invalid = true
          }
        }).catch((e) => {
          console.log(e)
        })
      }
    }
    // signIn () {
    //   if (this.username && this.password) {
    //     this.$store.dispatch('authModule/signIn', true)
    //   }
    // }
  },
  computed: {
    invalidUser () {
      return this.$store.state.auth.invalidUser
    },
    logo () {
      return logo
    }
  }
}
</script>

<style scoped>
.error-display {
  color: brown;
  padding-left: 3em;
}

.admin-title-style {
  color: white;
  font-weight: 200;
  letter-spacing: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue